import { render, staticRenderFns } from "./MyFavorites.vue?vue&type=template&id=e1080e6c&scoped=true"
import script from "./MyFavorites.vue?vue&type=script&lang=js"
export * from "./MyFavorites.vue?vue&type=script&lang=js"
import style0 from "./MyFavorites.vue?vue&type=style&index=0&id=e1080e6c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e1080e6c",
  null
  
)

export default component.exports